/* Hello couleur — page resultats de recherche (tabs categorie + highlight).
   Les cards sont rendues server-side (hc-card-product) avec data-format. On
   mappe data-format -> famille coarse pour les onglets, on compte, on filtre,
   et on surligne le terme recherche dans les titres. */
(function () {
  var grid = document.getElementById('results-grid');
  if (!grid) return;

  var FAMILY = {
    'carnet-a5': 'carnet', 'carnet-de-poche': 'carnet', 'bloc-notes': 'carnet',
    'carte-a6': 'carte', 'mini-carte': 'carte',
    'tirage': 'tirage',
    'petit-pack': 'pack', 'pack-standard': 'pack', 'grand-pack': 'pack',
    'pack-cartes': 'pack', 'pack-carnets': 'pack', 'pack-blocs': 'pack',
    'coffret': 'pack', 'stickers': 'pack',
    'peinture-originale': 'originaux'
  };

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
  cards.forEach(function (c) { c.dataset.family = FAMILY[c.dataset.format] || 'autre'; });

  // Compteurs par onglet
  var counts = { all: cards.length, carte: 0, carnet: 0, tirage: 0, pack: 0, originaux: 0 };
  cards.forEach(function (c) { if (counts[c.dataset.family] != null) counts[c.dataset.family]++; });
  document.querySelectorAll('.search-tab__count').forEach(function (el) {
    var k = el.dataset.count;
    el.textContent = counts[k] != null ? counts[k] : 0;
  });

  // Filtre onglet
  var tabs = document.querySelectorAll('.search-tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      var f = tab.dataset.filter;
      cards.forEach(function (c) {
        c.classList.toggle('hidden', !(f === 'all' || c.dataset.family === f));
      });
    });
  });

  // Highlight du terme dans les titres
  var term = (grid.dataset.searchTerm || '').trim();
  if (term) {
    var esc = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var re = new RegExp('(' + esc + ')', 'gi');
    cards.forEach(function (c) {
      var t = c.querySelector('.product-card__title');
      if (t && !t.querySelector('mark')) {
        t.innerHTML = t.textContent.replace(re, '<mark class="hc-search-hl">$1</mark>');
      }
    });
  }
})();
